export const AG_GRID_LOCALE_FI = {
  // Pagination
  page: 'Sivu',
  more: 'Lisää',
  to: '–',
  of: '/',
  next: 'Seuraava',
  last: 'Viimeinen',
  first: 'Ensimmäinen',
  previous: 'Edellinen',

  // Loading & No rows
  loadingOoo: 'Ladataan…',
  noRowsToShow: 'Ei näytettäviä rivejä',

  // Tool Panel
  selectAll: 'Valitse kaikki',
  searchOoo: 'Etsi…',
  blanks: '(Tyhjät)',

  // Filter panel
  filterOoo: 'Suodata…',
  applyFilter: 'Käytä',
  equals: 'Yhtä kuin',
  notEqual: 'Ei yhtä kuin',
  lessThan: 'Pienempi kuin',
  greaterThan: 'Suurempi kuin',
  lessThanOrEqual: 'Pienempi tai yhtä kuin',
  greaterThanOrEqual: 'Suurempi tai yhtä kuin',
  inRange: 'Alueella',
  contains: 'Sisältää',
  notContains: 'Ei sisällä',
  startsWith: 'Alkaa',
  endsWith: 'Päättyy',
  andCondition: 'JA',
  orCondition: 'TAI',

  // Filter buttons
  filter: 'Suodata',
  resetFilter: 'Nollaa',
  clearFilter: 'Tyhjennä',
  cancelFilter: 'Peruuta',

  // Excel export
  export: 'Vie',
  csvExport: 'Vie CSV-tiedostoon',
  excelExport: 'Vie Exceliin',

  // Clipboard
  copy: 'Kopioi',
  copyWithHeaders: 'Kopioi otsikoiden kanssa',
  paste: 'Liitä',

  // Columns tool panel
  toolPanelColumn: 'Sarake',
  toolPanelColumns: 'Sarakkeet',
  toolPanelDragAndDrop: 'Vedä ja pudota sarakkeita tähän.',
  toolPanelShowAll: 'Näytä kaikki',
  toolPanelHideAll: 'Piilota kaikki',

  // Columns menu
  columns: 'Sarakkeet',
  rowGroupColumns: 'Ryhmittele sarakkeiden mukaan',
  rowGroupColumnsEmptyMessage: 'Raahaa ryhmittelyä varten',
  valueColumns: 'Arvo-sarakkeet',
  pivotMode: 'Pivot-tila',
  groups: 'Ryhmat',
  rowGroup: 'Ryhmä',
  pivotColumns: 'Pivot-sarakkeet',
  pivotColumnsEmptyMessage: 'Raahaa pivotointia varten',
  valueColumnsEmptyMessage: 'Raahaa arvoja varten',
  toolPanelPivotMode: 'Pivot-tila',
  toolPanelValues: 'Arvot',
  toolPanelPivot: 'Pivot',
  toolPanelFilters: 'Suodattimet',
  filters: 'Suodattimet',

  // Column menu and general
  pivotRemove: 'Poista pivot-kenttä',
  valueAggFilter: 'Arvon suodatin',
  autosizeThiscolumn: 'Mukauta tämä sarake',
  autosizeAllColumns: 'Mukauta kaikki sarakkeet',
  groupBy: 'Ryhmittele',
  ungroupBy: 'Poista ryhmitys',
  resetColumns: 'Palauta sarakkeet',
  expandAll: 'Laajenna kaikki',
  collapseAll: 'Pienennä kaikki',
  toolPanelPivotSummary: 'Yhteenveto',
  value: 'Arvo',
  positions: 'Sarakkeen sijainti',
  top: 'Ylimmäinen',
  bottom: 'Alin',
  left: 'Vasen',
  right: 'Oikea',
  pivotChartAndPivotMode: 'Pivot-moduuli & Pivot-kaavio',
  pivotChart: 'Pivot-kaavio',
  chartRange: 'Kaavion alue',

  // Value aggregation
  sum: 'Summa',
  min: 'Minimi',
  max: 'Maksimi',
  none: 'Ei yhtään',
  count: 'Määrä',
  avg: 'Keskiarvo',
  filtered: 'Suodatettu',
  // Pivot mode
  // enterprise menu options
  served: 'Palveltiin',
  // other
  noDataToChart: 'Ei tietoja kaavioon',
  pivotChartTitle: 'Pivot-kaavio',
  pivotChartSubtitle: 'Pivot-kaavion alaotsikko',

  // OWN
  columnPercentage: '%',
};

export function mapValue(value) {
  return MAPPED_VALUES[value] || value;
}

const MAPPED_VALUES = {
  // LOPPUTULOS
  'vapaa': 'Vapaa',
  'karkilyonti': 'Kärkilyönti',
  'palo': 'Palo',
  'takapalo': 'Takapalo',
  'takaeteneminen': 'Takaeteneminen',
  'haava_kt': 'Haava KT',
  'haava': 'Haava',

  // LYÖNNIN TYYPIT
  'pystari/viisto': 'Pyke/viisto',
  'pomppu': 'Pomppu',
  'koppi': 'Koppi',
  'vaakamaila': 'Vaakamaila',
  'varsi': 'Varsi',
  'kumura': 'Kumura',
  'nappi': 'Näppi',
  'pussari': 'Pussari',
  'huti': 'Huti',

  // YLEINEN
  'muu': 'Muu',
  false: 'Ei',
  true: 'Kyllä',
  0: 'Ei',
  1: 'Kyllä'
}

export const columnDefs = () => {
  const baseColumns = [
    {
      headerName: '#',
      valueGetter: 'node.rowIndex + 1',
      width: 60,
      suppressMenu: true,
      pinned: 'left',
      sortable: false,
      filter: false
    },
    {
      field: 'hitter_name',
      headerName: 'Lyöjä',
      filter: 'agTextColumnFilter',
      enableRowGroup: true,
      width: 160,
      filterParams: {
        // only allow a single filter option like 'contains'
        filterOptions: ['contains'],  // or 'equals', 'startsWith', etc.
        suppressAndOrCondition: true  // disables the AND/OR logic
      },
    },
    {
      field: 'karkirunner_name',
      headerName: 'Kärki',
      enableRowGroup: true,
      width: 160,
      filter: 'agTextColumnFilter',
      filterParams: {
        // only allow a single filter option like 'contains'
        filterOptions: ['contains'],  // or 'equals', 'startsWith', etc.
        suppressAndOrCondition: true  // disables the AND/OR logic
      },
    },
    {
      field: 'bases_state',
      headerName: 'Tilanne',
      width: 100,
      filterParams: {
        values: ['0', '1', '1-2', 'Ajo', '0-2', '1-3', '0-3', '2-3'] ,
        suppressAndOrCondition: true,
        convertValuesToStrings: true
      }
    },
    {
      field: 'hit_outcome',
      headerName: 'Lopputulos',
      filter: true,
      enablePivot: true,
      enableValue: true,
      width: 130,
      valueGetter: (params) => mapValue(params.data.hit_outcome),
      allowedAggFuncs: ['count',  'sum', 'columnPercentage'],
      filterParams: {
        values: ['vapaa', 'karkilyonti', 'palo', 'takapalo', 'takaeteneminen', 'haava_kt', 'haava'],
        suppressAndOrCondition: true,
        // valueFormatter: (params) => mapValue(params.value) || params.value,
      }
    },
    {
      field: 'run_total_run_time',
      headerName: 'Etenemisaika',
      filter: 'agNumberColumnFilter',
      width: 120,
      allowedAggFuncs: ['avg', 'min', 'max', 'count', 'columnPercentage'],
      enableValue: true,
      valueFormatter: (params) => {
        const val = parseFloat(params.value);
        return isNaN(val) ? '' : val.toFixed(2) + ' s';
      },
      filterParams: {
        filterOptions: ['lessThan', 'greaterThan', 'inRange'],
        suppressAndOrCondition: true,
        numberParser: (text) => {
          if (typeof text === 'string') {
            // Replace comma with dot before parsing
            text = text.replace(',', '.');
          }
          const val = parseFloat(text);
          return isNaN(val) ? null : val;
        }
      },
      floatingFilter: false,
    },
    {
      field: 'hit_type',
      headerName: 'Lyönnin tyyppi',
      filter: true,
      enablePivot: true,
      width: 130,
      valueGetter: (params) => mapValue(params.data.hit_type),
      filterParams: {
        values: ['pystari/viisto', 'pomppu', 'koppi', 'vaakamaila'],
        suppressAndOrCondition: true,
        valueFormatter: (params) => mapValue(params.value) || params.value,
      }
    },

    // HIDE AFTER THIS
    {
      field: 'run_runner_distance_from_base',
      headerName: 'Etäisyys',
      filter: 'agNumberColumnFilter',
      width: 120,
      allowedAggFuncs: ['avg', 'min', 'max', 'count', 'columnPercentage'],
      enableValue: true,
      valueFormatter: (params) => {
        const val = parseFloat(params.value);
        return isNaN(val) ? '' : val.toFixed(2) + ' m'
      },
      filterParams: {
        filterOptions: ['lessThan', 'greaterThan', 'inRange'],
        suppressAndOrCondition: true,
        numberParser: (text) => {
          if (typeof text === 'string') {
            // Replace comma with dot before parsing
            text = text.replace(',', '.');
          }
          const val = parseFloat(text);
          return isNaN(val) ? null : val;
        }
      },
      floatingFilter: false,
    },
    {
      field: 'pitcher_name',
      headerName: 'Lukkari',
      filter: 'agTextColumnFilter',
      enableRowGroup: true,
      width: 160,
      hide: true,
      filterParams: {
        // only allow a single filter option like 'contains'
        filterOptions: ['contains'],  // or 'equals', 'startsWith', etc.
        suppressAndOrCondition: true  // disables the AND/OR logic
      },
    },
    {
      field: 'run_run_times_lahto',
      headerName: 'Lähtö',
      filter: 'agNumberColumnFilter',
      headerTooltip: 'Aika syötön nousemisesta siihen kun ponnistava jalka suorana',
      hide: true,
      valueFormatter: (params) => {
        const val = parseFloat(params.value);
        return isNaN(val) ? '' : val.toFixed(2) + ' s';
      },
      filterParams: {
        filterOptions: ['lessThan', 'greaterThan', 'inRange'],
        suppressAndOrCondition: true,
        numberParser: (text) => {
          if (typeof text === 'string') {
            // Replace comma with dot before parsing
            text = text.replace(',', '.');
          }
          const val = parseFloat(text);
          return isNaN(val) ? null : val;
        }
      },
      floatingFilter: false,
    },
    {
      field: 'run_run_times_juoksu',
      headerName: 'Raaka juoksu',
      filter: 'agNumberColumnFilter',
      headerTooltip: 'Aika syötön nousemisesta siihen kun ponnistava jalka suorana',
      hide: true,
      valueFormatter: (params) => {
        const val = parseFloat(params.value);
        return isNaN(val) ? '' : val.toFixed(2) + ' s';
      },
      filterParams: {
        filterOptions: ['lessThan', 'greaterThan', 'inRange'],
        suppressAndOrCondition: true,
        numberParser: (text) => {
          if (typeof text === 'string') {
            // Replace comma with dot before parsing
            text = text.replace(',', '.');
          }
          const val = parseFloat(text);
          return isNaN(val) ? null : val;
        }
      },
      floatingFilter: false,
    },
    {
      field: 'pitching_referee_name',
      headerName: 'Syöttötuomari',
      enableRowGroup: true,
      hide: true,
      width: 160,
      filter: 'agTextColumnFilter',
      filterParams: {
        // only allow a single filter option like 'contains'
        filterOptions: ['contains'],  // or 'equals', 'startsWith', etc.
        suppressAndOrCondition: true  // disables the AND/OR logic
      },
    },
    {
      field: 'stadion_name',
      headerName: 'Kenttä',
      enableRowGroup: true,
      hide: true,
      width: 160,
      filter: 'agTextColumnFilter',
      filterParams: {
        // only allow a single filter option like 'contains'
        filterOptions: ['contains'],  // or 'equals', 'startsWith', etc.
        suppressAndOrCondition: true  // disables the AND/OR logic
      },
    },
    {
      field: 'vapaataival',
      headerName: 'Vapaataival',
      valueGetter: (params) => mapValue(params.data.vapaataival),
      hide: true,
      filterParams: {
        values: [1, 0],
        suppressAndOrCondition: true,
        valueFormatter: (params) => mapValue(params.value),
        convertValuesToStrings: true
      }
    },
    {
      field: 'play_total_play_time',
      headerName: 'UP-aika',
      filter: 'agNumberColumnFilter',
      width: 120,
      enableValue: true,
      valueFormatter: (params) => {
        const val = parseFloat(params.value);
        return isNaN(val) ? '' : val.toFixed(2) + ' s';
      },
      filterParams: {
        filterOptions: ['lessThan', 'greaterThan', 'inRange'],
        suppressAndOrCondition: true,
        numberParser: (text) => {
          if (typeof text === 'string') {
            // Replace comma with dot before parsing
            text = text.replace(',', '.');
          }
          const val = parseFloat(text);
          return isNaN(val) ? null : val;
        }
      },
      floatingFilter: false,
    },
  ]

  return baseColumns;
}